import React, { useState, useContext, useMemo, useEffect, useCallback, } from "react";
import debounce from "lodash/debounce";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import _ from "lodash";
import styled from "styled-components";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import UserService from "services/UserService";
import axios from "axios";
import { getBillDashboard } from "services/ConfigServices";
import { energyData, sources, consoUnitData } from "variables/lists/bills";
import { billtext, billpagetext } from "variables/bills";
import { monthnameData } from "variables/lists/meters";
import moment from "moment";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { makeStyles } from "@mui/styles";
import ExportTableToCSV from "components/ExportTableToCSV/ExportTableToCSV";
import CustomSelect from "components/Input/CustomSelect.js";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import MuiDialogContent from "@mui/material/DialogContent";
import { withStyles } from "@mui/styles";
import LinearProgress from '@mui/material/LinearProgress';
import CustomSwitch from "components/Input/CustomSwitch.js";

const UploadButton = styled.div`
  margin-left: 0px;
  &:hover {
    cursor: pointer;
  }
  color: grey;
`;

const TableName = styled.h1`
  margin-right: auto;
  margin-left: -8px;
  font-size: 1.3rem;
  font-weight: 500;
`;

const FilterDiv = styled.div`
  margin-right: auto;
  margin-top: 1px;
  display: flex;
`;

const LoadingText = styled.div`
  font-weight: 600;
  font-size: 12px;
  font-family: "Source Sans Pro",sans-serif;
`;

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);


const useStyles = makeStyles(styles);

export default function useBillsTable() {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;

  const [shownodata, setShownodata] = useState(false)
  const [refresh, setRefresh] = useState(false);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [datesdata, setDatesdata] = useState([]);
  const [openloading, setOpenloading] = useState(null);
  const [columns, setColumns] = useState([]);
  const [year, setYear] = useState("")
  const [energychoice, setEnergychoice] = useState("choice");
  const [selectedPdls, setSelectedPdls] = useState([]);

  const classes = useStyles();

  const refreshTable = () => {
    setRefresh(!refresh);
  }

  //Ok but should not be able to change group at this level
  let prevIdGroup = ["0"];
  let prevRefresh = true;
  useEffect(() => {
    if (energychoice === 'choice')
      return;
    if (!year)
      return;
    if (chartIdGroup && chartIdGroup[0] !== "0") {
      if ((prevIdGroup && prevIdGroup === chartIdGroup)
        && (prevRefresh && prevRefresh === refresh)) {
        return;
      }
      setLoading(true);
      async function fetchData() {
        const response = await axios.get(
          getBillDashboard(chartIdGroup, energychoice, 0, year),
          {
            headers: {
              Authorization: `Bearer ${UserService.getToken()}`,
            },
          }
        );
        setResults(response.data);
        setLoading(false);
      }
      prevRefresh = refresh;
      prevIdGroup = chartIdGroup;
      fetchData();
    }
  }, [chartIdGroup, refresh, energychoice, year]);

  useEffect(() => {
    let datesdatatmp = [];
    let nowmoment = moment();
    let year = nowmoment.format("YYYY");
    datesdatatmp.push({ id: year, name: year});
    for (let i = 1; i <= 10; i++) {
      let substractedmoment = moment().subtract(i, 'year');
      let year = substractedmoment.format("YYYY");
      datesdatatmp.push({ id: year, name: year});
    }
    setDatesdata(datesdatatmp);
  }, []);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const SearchComponent = ({ filterText, onFilter, onClear }) => (
    <>
      <div style={{ marginTop: "-7px" }}>
        <TextField
          type="search"
          variant="outlined"
          margin="normal"
          size="small"
          autoFocus="true"
          value={filterText}
          onChange={onFilter}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </div>
    </>
  );


  const filteredItems = _.get(results, `pdllist`, []).filter(
    (item) =>
      (item.pdl && item.pdl.toLowerCase().includes(filterText.toLowerCase())) && (shownodata || item.data)
  );

  const handleEnergychoiceChange = (event) => { setEnergychoice(event.target.value); };
  const handleShownodataChange = (event) => { setShownodata(!shownodata); };
  const handleYearChange = (event) => { setYear(event.target.value); };

  const handleCloseLoading = () => {
    setOpenloading(false);
  };
  //OK
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };
    const onFilterText = (e) => setFilterText(e.target.value);


    let exportarray = selectedPdls.map((item) => {
      let billtoexport = {};

      billtoexport[billtext.pdl] = item.pdl;
      if (year) {
        let date = moment(year + '-01-01');
        for (let i = 0; i < 12; i++) {
          let month = monthnameData.find((obj) => obj.id === date.format("MMMM")).name;
          let year = date.format("YYYY");
          let monthkey = date.format("YYYY-MM");
          let daycount = date.daysInMonth();
          billtoexport[month + " " + year] = item[monthkey] ? Math.floor((item[monthkey] / daycount) * 100) + "%" : "0%";
          date = date.add(1, 'month');
        }
      }
      return billtoexport;
    });
    return (
      <>
        <FilterDiv>
          <CustomSelect
            inputTitle={billpagetext.energychoice}
            selectValue={energychoice}
            handleSelectValueChange={handleEnergychoiceChange}
            data={energyData}
          />
          <CustomSelect
            inputTitle={billpagetext.yearchoice}
            selectValue={year}
            handleSelectValueChange={handleYearChange}
            data={datesdata}
            width={100}
          />
          <CustomSwitch
            style={{ margin: "10px 0 0 20px", display: "flex", alignItems: "center" }}
            inputTitle={billpagetext.shownodata}
            checkedState={shownodata}
            handleSwitchChange={handleShownodataChange}
          />
          {/* <CustomSelect
            inputTitle={billpagetext.displaymethod}
            selectValue={displaymethod}
            handleSelectValueChange={handleDisplaymethodChange}
            data={displaymethodData}
          /> */}
        </FilterDiv>
        <SearchComponent
          key="SearchComponent"
          onFilter={onFilterText}
          onClear={handleClear}
          filterText={filterText}
        />
        {/* <UploadButton type="button" onClick={handleClear}>
          <ExportTableToCSV dataarray={exportarray} disabled={!selectedBills || selectedBills.length < 1} />
        </UploadButton>
         */}
        <Tooltip title="Exporter en CSV">
          <UploadButton type="button" onClick={handleClear}>
            <ExportTableToCSV dataarray={exportarray} disabled={!selectedPdls || selectedPdls.length < 1} />
          </UploadButton>
        </Tooltip>

        <Dialog
          onClose={handleCloseLoading}
          aria-labelledby="edituser-dialog-title"
          fullWidth="true"
          maxWidth="sm"
          open={openloading}
        >
          <DialogContent dividers>
            <LoadingText>Création de l'export en cours</LoadingText>
            <div style={{ height: 20, marginTop: 10 }}><LinearProgress /></div>
          </DialogContent>
        </Dialog>
      </>
    );
  }, [filterText, resetPaginationToggle, selectedPdls, energychoice, openloading, results, year, datesdata, columns, shownodata]);


  return {
    gridState: {
      defaultPageSize: 10,
      data: filteredItems,
      filterable: true,
      manual: true,
      paginationResetDefaultPage: resetPaginationToggle,
      subHeaderComponent: subHeaderComponentMemo,
      loading,
    },
    refetch: refreshTable,
    setSelectedPdls,
    year,
    columns,
    setColumns,
  };
}
